import React from 'react';
import { FormattedMessage } from 'react-intl';

function EligibilityFactors(props: { factors: string }) {
    const eligibilityFactDescription = props.factors;


    const RenderFactor = () => {
        return (
            <li>
                <span>
                    <FormattedMessage
                        id={eligibilityFactDescription}
                    />
                </span>
            </li>
        );

    };

    return (
        <RenderFactor />
    );
}

export default EligibilityFactors;